<template>
    <div>
        <v-row class="mt-4">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card
                    class="mx-auto"
                    outlined
                >
                
                <v-data-table
                    :headers="headers"
                    :items="object.data"
                    :options.sync="options"
                    :server-items-length="object.meta && object.meta.total"
                    class="elevation-1 table-striped caption"
                    :footer-props="{
                        'items-per-page-text':'Itens por página',
                        'items-per-page-options': [5, 10],
                        'items-per-page-all-text': '',
                        'page-text': '{0}-{1} de {2}'
                    }"
                >
                    <template v-slot:[`item.nome`]="{ item }">
                        <span class="font-weight-bold">{{ item.nome }}</span>
                        <div>
                            <span :class="$css_report_list">{{ item.url }}</span>
                            <v-icon  
                                class="ml-2"
                                small
                                @click="copyPaste(item.url)"
                            >
                                mdi-content-copy
                            </v-icon>
                        </div>
                    </template>

                    <template v-slot:[`item.due_date`]="{ item }">
                        <v-chip
                            :color="statusDueDate(item)"
                            label
                            small
                        >
                            {{ formatDate(item.due_date) }}
                        </v-chip>
                    </template>

                    <template v-slot:[`item.payment_date`]="{ item }">
                        <v-chip
                            v-if="item.payment_date"
                            label
                            small
                        >
                            {{ formatDate(item.payment_date) }}
                        </v-chip>
                    </template>

                    <template v-slot:[`item.invoice_date`]="{ item }">
                        <v-chip
                            v-if="item.invoice_date"
                            label
                            small
                        >
                            {{ formatDate(item.invoice_date) }}
                        </v-chip>
                    </template>

                    <template v-slot:[`item.total`]="{ item }">
                        <span :class="$css_report_list">R$ {{ setTotal(item.account_values) }}</span>
                        <v-menu
                            open-on-click
                            top
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon  
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ml-1"
                                    color="red"
                                >
                                    mdi-information-variant-circle-outline
                                </v-icon>
                            </template>
    
                            <v-simple-table>
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            DESCRIÇÃO
                                        </th>
                                        <th class="text-left">
                                            R$
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="itm in item.account_values" :key="itm.id">
                                        <td>{{ itm.description }}</td>
                                        <td>R$ {{ itm.value }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="text-center font-weight-bold">{{ item.nome }}</td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                        </v-menu>

                    </template>

                    <template v-slot:[`item.comments`]="{ item }">
                        <v-menu
                            v-if="item.comments && item.comments.length > 0"
                            open-on-click
                            top
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon  
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ml-1"
                                    color="blue"
                                >
                                    mdi-history
                                </v-icon>
                            </template>
    
                            <v-simple-table>
                                <template v-slot:default>
                                <tbody>
                                    <tr v-for="itm in item.comments" :key="itm.id">
                                        <td>
                                            <span :class="$css_report_list + ' font-weight-bold'">{{ itm.user }} - {{ formatDateTime(itm.created_at) }}</span> <br />
                                            <span :class="$css_report_list">{{ itm.comment }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="text-center font-weight-bold">{{ item.nome }}</td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                        </v-menu>

                    </template>

                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip
                            :color="item.status | statusPAI"
                            label
                            small
                        >
                            {{ item.status }}
                        </v-chip> 
                    </template>
                    
                    <template v-slot:[`item.dados_contato`]="{ item }">
                        <div>
                            <v-menu
                                open-on-click
                                :close-on-content-click="false"
                                top
                                offset-y
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon  
                                        v-bind="attrs"
                                        v-on="on"

                                    >
                                        mdi-card-account-mail-outline
                                    </v-icon>
                                </template>

                                <v-simple-table>
                                    <template v-slot:default>
                                    <tbody>
                                        <tr v-if="item.telefone1">
                                            <td>Telefone 1: </td>
                                            <td>
                                                <phone-component :object="item.telefone1"></phone-component> 
                                            </td>
                                            <td>
                                                <span class="ml-2">
                                                    <v-icon  
                                                        small
                                                        @click="copyPaste(item.telefone1)"
                                                    >
                                                        mdi-content-copy
                                                    </v-icon>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="item.telefone2">
                                            <td>Telefone 2: </td>
                                            <td><phone-component :object="item.telefone2"></phone-component></td>
                                            <td>
                                                <span class="ml-2">
                                                    <v-icon  
                                                        small
                                                        @click="copyPaste(item.telefone2)"
                                                    >
                                                        mdi-content-copy
                                                    </v-icon>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="item.email1">
                                            <td>E-mail 1: </td>
                                            <td>{{ item.email1 }}</td>
                                            <td>
                                                <span class="ml-2">
                                                    <v-icon  
                                                        small
                                                        @click="copyPaste(item.email1)"
                                                    >
                                                        mdi-content-copy
                                                    </v-icon>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="item.email2">
                                            <td>E-mail 2: </td>
                                            <td>{{ item.email2 }}</td>
                                            <td>
                                                <span class="ml-2">
                                                    <v-icon  
                                                        small
                                                        @click="copyPaste(item.email2)"
                                                    >
                                                        mdi-content-copy
                                                    </v-icon>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="text-center font-weight-bold">{{ item.nome }}</td>
                                            <td>
                                                <span class="ml-2">
                                                    <v-icon  
                                                        small
                                                        @click="copyPaste(item.telefone1)"
                                                    >
                                                        mdi-content-copy
                                                    </v-icon>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                            </v-menu>
                        </div>
                    </template>

                    <template v-slot:[`item.dados_nf`]="{ item }">
                        <div>
                            <v-menu
                                open-on-click
                                :close-on-content-click="false"
                                top
                                offset-y
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon  
                                        v-bind="attrs"
                                        v-on="on"

                                    >
                                        mdi-invoice-text-check-outline
                                    </v-icon>
                                </template>

                                <v-simple-table>
                                    <template v-slot:default>
                                    <tbody>
                                        <tr v-if="item.invoice_doc">
                                            <td>DOC: </td>
                                            <td>{{ item.invoice_doc }}</td>
                                            <td>
                                                <v-icon  
                                                    small
                                                    @click="copyPaste(item.invoice_doc)"
                                                >
                                                    mdi-content-copy
                                                </v-icon>
                                            </td>
                                        </tr>
                                        <tr v-if="item.invoice_name">
                                            <td>NOME: </td>
                                            <td>{{ item.invoice_name }}</td>
                                            <td>
                                                <v-icon  
                                                    small
                                                    @click="copyPaste(item.invoice_name)"
                                                >
                                                    mdi-content-copy
                                                </v-icon>
                                            </td>
                                        </tr>
                                        <tr v-if="item.endereco">
                                            <td>Endereço: </td>
                                            <td>
                                                {{ item.endereco }}
                                                <span v-if="item.numero">, {{ item.numero }}</span>
                                                <span v-if="item.complemento"> - {{ item.complemento }}</span>
                                                <span v-if="item.cep"> - CEP {{ item.cep }}</span>
                                            </td>
                                            <td>
                                                <v-icon  
                                                    small
                                                    @click="copyPaste(item.endereco + ' ' + item.numero + ' ' + item.complemento)"
                                                >
                                                    mdi-content-copy
                                                </v-icon>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="text-center font-weight-bold">{{ item.nome }}</td>
                                            <td>
                                                <v-icon  
                                                    small
                                                    @click="copyPaste(item.invoice_name)"
                                                >
                                                    mdi-content-copy
                                                </v-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                                    </template>
                                </v-simple-table>
                            </v-menu>
                        </div>
                    </template>


                    <template v-slot:[`item.actions`]="{ item }">
                        <v-card-actions>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click.prevent="editItem(item.id)" class="ml-8">
                                        <v-icon v-bind="attrs" v-on="on">mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar</span>
                            </v-tooltip>

                             <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon @click.prevent="confirmDestroy(item)" class="ml-8">
                                        <v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Excluir</span>
                            </v-tooltip>
                        </v-card-actions>     
                    </template> 
                </v-data-table>
               
                </v-card>
            </v-col>
        </v-row>

    </div>
</template>

<script>
import PhoneComponent from '@/components/phone/PhoneComponent.vue'

export default {

    components: {
        PhoneComponent
    },

    props: {
        object: {},

        filters: {},
    }, 

    watch: {
        options: {
            handler() {
                if(this.options.page >= 1){
                    this.loadItems();
                }   
            },
        },

        filters () {
            this.options.page = 1
        },

    },

    data () {
        return {
            options: {
                page: 1,
                itemsPerPage: 10,
            },

            headers: [
                { text: 'STATUS', value: 'status' , sortable: false},  
                { text: 'NOME', value: 'nome' , sortable: false}, 
                { text: 'DT. VENC.', value: 'due_date' , sortable: false},  
                { text: 'DT. PAG.', value: 'payment_date' , sortable: false},  
                { text: 'DT. NF', value: 'invoice_date' , sortable: false}, 
                { text: 'R$', value: 'total' , sortable: false},   
                { text: 'HIST.', value: 'comments' , sortable: false},  
                { text: 'CONTATO', value: 'dados_contato' , sortable: false},  
                { text: 'DADOS NF', value: 'dados_nf' , sortable: false},  
                { text: 'AÇÕES', value: 'actions', sortable: false },
            ],

            confirmDelete: {
                id: '',
                status: false,
                name: '',
                text: '',
                destroyfunction: '',
            },
        }    
    },

    filters: {
        userProfileColor (value) {
            if(!value) return ''
            if(value == 'Gerente') return 'blue lighten-4'
            else if(value == 'Master') return 'orange lighten-4'
            else if(value == 'Corretor') return 'green lighten-4'
            else return ''
        },
    },

    methods: {
        loadItems(){
            this.params = this.filters 
            this.params.page = this.options.page
            if(this.options.itemsPerPage && this.options.itemsPerPage > 0){
                this.params.paginate = this.options.itemsPerPage
            }
            this.$emit('callLoadItems', this.params)   
        },

        openCloseDialog() {
            this.dialog = !this.dialog
        },

        editItem(id){
            this.$emit('callEditItem', id)
        },

        confirmDestroy(item) {
            this.$snotify.error(`Tem certeza que deseja excluir esse registro?`, 'Confirmaçāo', {
                timeout: 10000,
                showProgressBar: true,
                closeоnClick: true,
                buttons: [
                    {text: 'Nāo', action: this.$snotify.remove()},
                    {text: 'Sim', action: () => {
                        this.destroy(item)
                        this.$snotify.remove()
                    }},
                ]
            })
        },

        destroy(item){
            this.$store.dispatch('destroyAccount', item.id)
                        .then(() => {
                            this.$snotify.success(`Registro excluído com sucesso`, 'Delete')
                            this.$emit('callLoadItems')
                        })
                        .catch(error => {
                            this.$snotify.error('error', error)
                        })
        },

        setTotal(json){
            let total = 0
            if(json && json.length > 0){
                json.forEach(model => {
                    if(model.type == 'Crédito'){
                        total += model.value 
                    }
                })
            }
            return total
        },
    },
}
</script>
